import { Injectable } from '@angular/core';
import { UserLoginResult } from '../interface/userLoginResult.interface';
import { UserData } from '../interface/userData.interface';
import UserUtils from '../utils/user.utils';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly SESSION_KEY = 'sessionData';

  getSession(): UserLoginResult | null {
    try {
      const raw = sessionStorage.getItem(this.SESSION_KEY)
             ?? localStorage.getItem(this.SESSION_KEY);
      return raw ? (JSON.parse(raw) as UserLoginResult) : null;
    } catch {
      return null;
    }
  }

  getUser(): UserData | null {
    return this.getSession()?.response?.user ?? null;
  }

  isAuthenticated(): boolean {
    return this.getSession() !== null;
  }

  isAdmin(): boolean {
    return this.getUser()?.securityLevel === UserUtils.SECURITY_LEVEL_ADMIN;
  }

  isAffiliate(): boolean {
    const user = this.getUser();
    return !!user?.active && user.idUserRole === UserUtils.USERROLE_SALESPERSON;
  }

  isEmployer(): boolean {
    const user = this.getUser();
    return !!user?.active && user.idUserRole === UserUtils.USERROLE_EMPLOYER;
  }

  saveSession(data: UserLoginResult, rememberMe = false): void {
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem(this.SESSION_KEY, JSON.stringify(data));
  }

  clearSession(): void {
    sessionStorage.removeItem(this.SESSION_KEY);
    localStorage.removeItem(this.SESSION_KEY);
  }
}
